<template>
  <div class="p-5">
    <b-row class="my-5">
      <b-col v-if="isMobileDevice" class="my-2" md="6">
        <b-form-checkbox  v-model="currencyUSD"  >View in USD</b-form-checkbox>    
      </b-col>
      <b-col class="my-2" md="6">
        <multiselect-dropdown
          v-if="dateRangeList.length"
          :options="dateRangeList" 
          :multiple="true"
          :sideSingle="true"
          allLabel="All Time"
          :value="queryMonths"
          @item-select="filterByPeriod"/>
      </b-col>
      <b-col class="my-2" md="6">
        <multiselect-dropdown
          v-if="merchantsList.length"
          class="w-100"
          :options="merchantsList"
          :hasMore="hasMoreMerchants"
          :loadingMore="merchantsLoadingMore"
          :searchResults="merchantsSearchResults"
          :searchResultsLoading="merchantsSearchLoading"
          allLabel="All Merchants"
          :multiple="true"
          :sideSingle="true"
          :value="queryMerchant"
          @item-select="filterByMerchants"
          @load-more="loadMoreMerchants"
          @search-input="onMerchantsSearchInput"/>
      </b-col>
    </b-row>
    <b-table
      :items="monthlyData"
      :fields="table_fields"
      :sticky-header="tableheight"
      :busy="isloading"
      head-variant="light"
      striped bordered hover no-border-collapse 
      show-empty responsive
        >
      <template  #head()="monthlyData">
        <span>{{ monthlyData.field.title.toUpperCase() }}</span>
      </template>
      <template #cell(invoice_count)="item">
        <AmountColumn :value="item.value" />
      </template>
      <template #cell(invoice_amount_aed)="item">
          <AmountColumn :value="item.value" />
      </template>
      <template #cell(invoice_amount_usd)="item">
        <AmountColumn :value="item.value" />
      </template>
      <template #cell(payment_count)="item">
        <AmountColumn :value="item.value" />
      </template>
      <template #cell(payment_amount_aed)="item">
          <AmountColumn :value="item.value" />
      </template>
      <template #cell(payment_amount_usd)="item">
        <AmountColumn :value="item.value" />
      </template>
      <template slot="bottom-row" slot-scope="data">
        <td v-for="field, index in data.fields" class="font-weight-boldest b-table-sticky-column">
          <span v-if="index===0">Total</span>
          <AmountColumn v-else :value="footRow[field.key]" />
        </td>
      </template>
      <template #table-busy>
        <div class="text-center my-2 p-2">
          <b-spinner class="align-middle p-2 mr-2"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
    <MonthlyTotalCard v-if="footRow" 
      :invoiceCount="footRow['invoice_count']"
      :invoiceAmountAed="footRow['invoice_amount_aed']"
      :invoiceAmountUsd="footRow['invoice_amount_usd']"
      :paymentCount="footRow['payment_count']"
      :paymentAmountAed="footRow['payment_amount_aed']"
      :paymentAmountUsd="footRow['payment_amount_usd']"
      />
  </div>
</template>
  
<script>
import MonthlyDataService from '@/services/monthlydata.service';
import { GET_ALL_MERCHANTS, LOAD_MORE_MERCHANTS, SEARCH_MERCHANTS, CLEAR_MERCHANTS_SEARCH } from "@/store/monthlydata";
import { mapState } from 'vuex';
import MultiselectDropdown from "../../../components/multiselect.dropdown.vue";
import { DateTime } from "luxon";
import { validateAdminQueryParameter } from "@/store/invoice/helpers";
import { QUERY_PARAMETERS_ACTIONS } from "@/store/queryparams";
import AmountColumn from './components/amountColumn.vue';
import MonthlyTotalCard from './components/monthlyTotalCard.vue';

export default {
  components: {MultiselectDropdown, AmountColumn, MonthlyTotalCard},
  data() {
    return {
      currencyUSD:false,
      isBusy: false,
      term: "All Merchants",
      tableheight:"calc("+window.innerHeight+'px - 250px)',
      monthlyData:[],
      dateRangeList:[],
      selectedMerchant:null,
      periodList:[],
      selectedPeriod:null,
      isloading:false,
      queryMerchant:null,
      queryMonths : null,
    }
  },
  mounted(){
    this.generate_period_options()
    this.$store.dispatch(GET_ALL_MERCHANTS, {is_merchant: "True"})
      .catch(({ message }) => {
            this.error = "There was an error loading companies.";
          });
    if (this.$route.query.period) {
          this.queryMonths = this.$route.query.period.split(",");
          this.selectedPeriod=this.queryMonths.map(query => {
            let period = this.dateRangeList.find((obj)=> obj.id == query)
            return period.value
          });
      }
      if(this.$route.query.id){
          this.queryMerchant = this.$route.query.id.split(",");
          this.selectedMerchant = this.$route.query.id.split(",");
      }
    this.getMonthlydata();
  },
  computed:{
    ...mapState({
      merchantsList:(state)=> state.monthlydata.merchants,
    }),
    hasMoreMerchants() {
      return !!this.$store.state.monthlydata.merchantsNextPageUrl;
    },
    merchantsLoadingMore() {
      return this.$store.state.monthlydata.merchantsLoadingMore;
    },
    merchantsSearchResults() {
      return this.$store.state.monthlydata.merchantsSearchResults || [];
    },
    merchantsSearchLoading() {
      return this.$store.state.monthlydata.merchantsSearchLoading;
    },
    isMobileDevice:function(){
      let regexp = /android|iphone|kindle|ipad/i;
      return regexp.test(navigator.userAgent) || screen.width <= 600;
    },
    table_fields:function(){
      let fields = []
      if (this.monthlyData && this.monthlyData.length ){
        if('merchant' in this.monthlyData[0]){
          fields.push({ title: 'Merchant',key:'merchant', stickyColumn: true, sortable: true , isRowHeader:true});
        }
        if('period' in this.monthlyData[0]){
          fields.push({ title: 'Period',key:'period', stickyColumn: true, isRowHeader:true});
        }
      }
      if(this.isMobileDevice){
        fields = fields.concat([
            { title: 'Invoices', key:'invoice_count', sortable: true, },
            this.currencyUSD?[{ title: 'Invoice Volume (USD)', key:'invoice_amount_usd', sortable: true }]:[{ title: 'Invoice Volume (AED)', key:'invoice_amount_aed', sortable: true}],
            { title: 'Payments', key:'payment_count', sortable: true },
            this.currencyUSD?[{ title: 'Payments Volume (USD)', key:'payment_amount_usd', sortable: true }]: [{ title: 'Payments Volume (AED)', key:'payment_amount_aed', sortable: true }],
          ]);
      }else {
        fields = fields.concat([
            { title: 'Invoices', key:'invoice_count', sortable: true, },
            { title: 'Invoice Volume (AED)', key:'invoice_amount_aed', sortable: true},
            { title: 'Invoice Volume (USD)', key:'invoice_amount_usd', sortable: true },
            { title: 'Payments', key:'payment_count', sortable: true },
            { title: 'Payments Volume (AED)', key:'payment_amount_aed', sortable: true },
            { title: 'Payments Volume (USD)', key:'payment_amount_usd', sortable: true },
          ])
      }
      return fields
    },
    footRow: function(){
      const keysToSum = ["invoice_count", "invoice_amount_aed", "invoice_amount_usd", "payment_count", "payment_amount_aed", "payment_amount_usd"];
      if(!this.monthlyData){
        return null
      }
      let initialRow = keysToSum.map((key)=>({[key]:0})).reduce((combined, value) => ({...combined, ...value}), {})
      
      const footerRow = this.monthlyData.reduce((total, current)=>{
        for (let key in current){
          if(!keysToSum.includes(key)){
            continue;
          } 
          total[key] += parseFloat(current[key])
        }

        return total
      },initialRow);
      footerRow['merchant'] = "Total"
      footerRow['period'] = "Total"
      return footerRow
    }
  },
  methods: {
    generate_period_options() {
      const start_year = 2023 // 2023-01
      const current_year = new Date().getFullYear()
      const current_month = new Date().getMonth() + 1
      const total_months = ((current_year - start_year) * 12) + current_month
      let month = current_month;
      let year = current_year
      for (let i = total_months; i > 0; i--) {
        const period_string = `${year}-${month < 10 ? 0 : ""}${month}`
        this.dateRangeList.push({
          id: period_string, name: period_string, value: { month, year }
        });
        month -= 1
        if (month < 1) {
          month = 12
          year -= 1
        }
      }

    },
    getMonthlydata() {
      const today = DateTime.now().startOf('day');
      this.isloading = true
      this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS);
      let currentPath = this.$route.path;
      let payLoad = {}
      if (this.selectedMerchant) {
        payLoad['id'] = this.selectedMerchant;
        const payload = validateAdminQueryParameter({ 'id': this.selectedMerchant.join(',') });
        this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.ADD_FILTER_QUERY_PARAMETER, { payload, currentPath })
      }
      if (this.selectedPeriod) {
        payLoad["date_ranges"] = this.selectedPeriod;
        const payload = validateAdminQueryParameter({ 'period': this.queryMonths.join(',') });
        this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.ADD_FILTER_QUERY_PARAMETER, { payload, currentPath })
      }

      MonthlyDataService.post(payLoad)
        .then(({ data }) => {
          this.monthlyData = data
          this.isloading = false;
          // if(data['no_exchange_currencies'].length >0){
          //   this.$showAlert('Exchange rates are not available for '+ data['no_exchange_currencies'].toString(),'danger');
          // }
        })
        .catch((error) => {
          console.log(error);
          this.$showAlert("Something went wrong!", 'danger');
        })
        .finally(() => {
          this.isloading = false;
        });

    },
    loadMoreMerchants() {
      this.$store.dispatch(LOAD_MORE_MERCHANTS);
    },
    onMerchantsSearchInput(term) {
      if (!term || !term.trim()) {
        this.$store.dispatch(CLEAR_MERCHANTS_SEARCH);
      } else {
        this.$store.dispatch(SEARCH_MERCHANTS, { search: term.trim(), is_merchant: 'True' });
      }
    },
    filterByMerchants(selectedItems) {
      if (selectedItems == null || selectedItems.length == 0) {
        this.selectedMerchant = null;
        this.getMonthlydata();
      }
      if (selectedItems.length > 0) {
        this.selectedMerchant = selectedItems.map((item) => item.id);
        this.getMonthlydata()
      }
    },
    filterByPeriod(selectedItems) {
      if (selectedItems == null || selectedItems.length == 0) {
        this.selectedPeriod = null;
        this.queryMonths = '';
        this.getMonthlydata();
        return;
      }
      this.queryMonths = selectedItems.map((obj) => obj.id);
      this.selectedPeriod = selectedItems.map((period) => period.value)
      this.getMonthlydata()
    },
  },
}
</script>